<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      center
      width="600px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-form id="form_exportAis" method="post" v-loading="loading">
        <input type="input" name="export_ids" :value="export_ids" />
        <input type="input" name="fields" :value="fields" />
        <input type="input" name="order" :value="order" />
        <input type="input" name="where_student_no" :value="where_student_no" />
        <input type="input" name="where_name" :value="where_name" />
        <input type="input" name="where_programme" :value="where_programme" />
        <input
          type="input"
          name="where_journal_time"
          :value="where_journal_time"
        />
        <input type="input" name="where_content" :value="where_content" />
        <input type="input" name="where_money" :value="where_money" />
        <input type="input" name="where_remark" :value="where_remark" />
        <input type="input" name="where_type" :value="where_type" />
        <input type="input" name="where_relation" :value="where_relation" />
        <input type="input" name="where_year" :value="where_year" />
        <input
          type="input"
          name="where_bill_status"
          :value="where_bill_status"
        />
        <input
          type="input"
          name="where_certificate_status"
          :value="where_certificate_status"
        />
        <input
          type="input"
          name="where_alumni_type"
          :value="where_alumni_type"
        />

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      export_ids: "",
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      fields: "",
      order: "",
      where_student_no: "",
      where_name: "",
      where_programme: "",
      where_journal_time: "",
      where_type: "",
      where_content: "",
      where_money: "",
      where_remark: "",
      where_relation: "",
      where_year: "",
      where_bill_status: "",
      where_certificate_status: "",
      where_alumni_type: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(
      checkList,
      order,
      where_student_no,
      where_name,
      where_programme,
      where_journal_time,
      where_content,
      where_money,
      where_type,
      where_remark,
      where_relation,
      where_year,
      where_bill_status,
      where_certificate_status,
      where_alumni_type,
      ids
    ) {
      // var time = ''
      // if (journalTime.length > 0) {
      //   time = journalTime[0] + '-' + journalTime[1]
      // }
      // var where_year = ''
      // if (!StrUtils.isEmpty(whereYear)) {
      //   where_year = whereYear[0] + '-' + whereYear[1]
      // }
      if (ids) {
        this.export_ids = ids;
      } else {
        this.export_ids = "";
      }
      this.changVisible = true;
      this.fields = StrUtils.getJournalInfoFields(checkList);
      this.order = order;
      this.where_student_no = where_student_no;
      this.where_name = where_name;
      this.where_programme = StrUtils.replaceFields(where_programme.toString());
      // this.where_journal_time = time

      this.where_year =
        where_year.length == 0 ? "" : where_year[0] + "-" + where_year[1];
      this.where_journal_time =
        where_journal_time.length == 0
          ? ""
          : where_journal_time[0] + "-" + where_journal_time[1];

      this.where_content = where_content;
      this.where_money = where_money;
      this.where_remark = where_remark;
      this.where_relation = where_relation;
      // this.where_year = where_year
      this.where_bill_status = where_bill_status;
      this.where_certificate_status = where_certificate_status;
      if (where_alumni_type != null) {
        this.where_alumni_type = StrUtils.replaceFields(
          where_alumni_type.toString()
        );
      }
      if (where_type != null) {
        this.where_type = StrUtils.replaceFields(
          where_type.toString()
        );
      }
      // this.where_type = where_type;
      this.$nextTick(() => {
        const from = document.getElementById("form_exportAis");
        from.action =
          URL_PATH + CApi.api_exportAisJournal + "?token=" + this.token;
        from.submit();
        this.close();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
input {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportAisJournalDialog.vue